<template>
    <section class="section-module booking-admin-create-module">
        <template v-if="customData.partner.length > 0">
            <div class="tabs-wrapper">
                <!-- Nav Tabs -->
                <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button
                            class="nav-link active"
                            id="create-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#create"
                            type="button"
                            role="tab"
                            aria-controls="create"
                            aria-selected="true"
                        >
                            Nova reserva
                        </button>
                    </li>

                    <li class="nav-item" role="presentation">
                        <button
                            class="nav-link"
                            id="list-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#list"
                            type="button"
                            role="tab"
                            aria-controls="list"
                            aria-selected="false"
                        >
                            Reservas criadas por administradores
                        </button>
                    </li>
                </ul>

                <!-- Nav Tabs Content -->
                <div class="tab-content">
                    <div
                        class="tab-pane fade show active first-tab-create"
                        id="create"
                        role="tabpanel"
                        aria-labelledby="create-tab"
                    >
                        <!-- Booking Create -->
                        <form
                            class="form-module admin-backoffice-create-booking"
                            method="post"
                            action=""
                            aria-describedby="Create Booking"
                            enctype="application/x-www-form-urlencoded"
                            autocomplete="on"
                        >
                            <fieldset class="">
                                <legend class="heading-6">
                                    1 - Seleciona o espaço e a parceria
                                </legend>

                                <div class="inputs-wrapper">
                                    <div class="input-group">
                                        <label
                                            class="body-1 strong-600"
                                            for="bookinglocation"
                                            >Localização</label
                                        >

                                        <select
                                            class="form-select"
                                            id="bookinglocation"
                                            aria-label="Select Location"
                                            @change="
                                                setItem(
                                                    'location_id',
                                                    $event,
                                                    'default'
                                                )
                                            "
                                        >
                                            <option
                                                v-for="(
                                                    value, index
                                                ) in customData.location"
                                                :key="index"
                                                :value="value.id"
                                                :selected="index === 0"
                                            >
                                                {{ value.name }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="input-group">
                                        <label
                                            class="body-1 strong-600"
                                            for="bookingoffice"
                                            >Espaço</label
                                        >

                                        <select
                                            class="form-select"
                                            id="bookingoffice"
                                            aria-label="Select Office"
                                            @change="
                                                setItem(
                                                    'office_id',
                                                    $event,
                                                    'default'
                                                )
                                            "
                                        >
                                            <option
                                                v-for="(
                                                    value, index
                                                ) in offices"
                                                :key="index"
                                                :value="value.id"
                                                :selected="index === 0"
                                            >
                                                {{ value.name }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="input-group">
                                        <label
                                            class="body-1 strong-600"
                                            for="bookingpartner"
                                            >Parceria</label
                                        >

                                        <select
                                            class="form-select"
                                            id="bookingpartner"
                                            aria-label="Select Partner"
                                            @change="
                                                setItem(
                                                    'partner_id',
                                                    $event,
                                                    'default'
                                                )
                                            "
                                        >
                                            <option
                                                v-for="(
                                                    value, index
                                                ) in customData.partner"
                                                :key="index"
                                                :value="value.user_id"
                                                :selected="index === 0"
                                            >
                                                {{ value.position }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </fieldset>

                            <fieldset class="">
                                <legend class="heading-6">
                                    2 - Seleciona a data
                                </legend>

                                <div class="inputs-wrapper">
                                    <div class="input-group">
                                        <label
                                            class="body-1 strong-600"
                                            for="bookingday"
                                            >Dia</label
                                        >

                                        <select
                                            class="form-select"
                                            id="bookingday"
                                            aria-label="Select Day"
                                            @change="
                                                setItem(
                                                    'day',
                                                    $event,
                                                    'default'
                                                )
                                            "
                                        >
                                            <option
                                                v-for="(
                                                    value, index
                                                ) in customData.days"
                                                :key="index"
                                                :value="value"
                                                :selected="
                                                    value ===
                                                    createbookingobj.day
                                                "
                                            >
                                                {{ value }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="input-group">
                                        <label
                                            class="body-1 strong-600"
                                            for="bookingmonth"
                                            >Mês</label
                                        >

                                        <select
                                            class="form-select"
                                            id="bookingmonth"
                                            aria-label="Select Month"
                                            @change="
                                                setItem(
                                                    'month',
                                                    $event,
                                                    'default'
                                                )
                                            "
                                        >
                                            <option
                                                v-for="(
                                                    value, index
                                                ) in customData.months"
                                                :key="index"
                                                :value="index"
                                                :selected="
                                                    parseInt(index) ===
                                                    createbookingobj.month
                                                "
                                            >
                                                {{ value }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="input-group">
                                        <label
                                            class="body-1 strong-600"
                                            for="bookingyear"
                                            >Ano</label
                                        >

                                        <select
                                            class="form-select"
                                            id="bookingyear"
                                            aria-label="Select Year"
                                            @change="
                                                setItem(
                                                    'year',
                                                    $event,
                                                    'default'
                                                )
                                            "
                                        >
                                            <option
                                                v-for="(
                                                    value, index
                                                ) in customData.years"
                                                :key="index"
                                                :value="value"
                                                :selected="
                                                    parseInt(value) ===
                                                    createbookingobj.year
                                                "
                                            >
                                                {{ value }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </fieldset>

                            <fieldset class="">
                                <legend class="heading-6">
                                    3 - Seleciona a hora
                                </legend>

                                <div class="inputs-wrapper">
                                    <div class="input-group">
                                        <label
                                            class="body-1 strong-600"
                                            for="bookingbeginhour"
                                            >Início</label
                                        >

                                        <select
                                            class="form-select"
                                            id="bookingbeginhour"
                                            aria-label="Select Begin Hour"
                                            @change="
                                                setItem(
                                                    'begin',
                                                    $event,
                                                    'turndata'
                                                )
                                            "
                                        >
                                            <option
                                                v-for="(
                                                    value, index
                                                ) in customData.hours"
                                                :key="index"
                                                :value="value"
                                                :selected="index === 0"
                                            >
                                                {{ value }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="input-group">
                                        <label
                                            class="body-1 strong-600"
                                            for="bookingendhour"
                                            >Fim</label
                                        >

                                        <select
                                            class="form-select"
                                            id="bookingendhour"
                                            aria-label="Select End Hour"
                                            @change="
                                                setItem(
                                                    'end',
                                                    $event,
                                                    'turndata'
                                                )
                                            "
                                        >
                                            <option
                                                v-for="(
                                                    value, index
                                                ) in customData.hours"
                                                :key="index"
                                                :value="value"
                                                :selected="
                                                    index ===
                                                    customData.hours.length - 1
                                                "
                                            >
                                                {{ value }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </fieldset>

                            <div class="btns-wrapper">
                                <button
                                    type="button"
                                    class="btn btn-primary"
                                    @click="addBookingDate()"
                                >
                                    <span class="button-body strong-500"
                                        >Adicionar data</span
                                    >
                                </button>
                            </div>
                        </form>

                        <!-- Booking Date Content -->
                        <div
                            id="create-content-booking"
                            class="create-content-booking"
                            @click="buttonsActions($event)"
                        ></div>

                        <!-- Submit Booking -->
                        <button
                            v-if="createbookinglist.length > 0"
                            type="submit"
                            class="btn btn-primary btn-confirm-booking"
                            :disabled="disabled"
                            @click="sendData()"
                        >
                            Confirmar reserva
                        </button>
                    </div>

                    <div
                        class="tab-pane fade second-tab-show-list"
                        id="list"
                        role="tabpanel"
                        aria-labelledby="list-tab"
                    >
                        <!-- Booking List -->
                        <template v-if="bookingData.length > 0">
                            <div class="admin-backoffice-booking-list">
                                <div class="inputs-wrapper">
                                    <div class="input-group">
                                        <label
                                            class="body-1 strong-600"
                                            for="filtermonth"
                                            >Filtrar por mês</label
                                        >

                                        <select
                                            class="form-select"
                                            id="filtermonth"
                                            aria-label="Select Month"
                                            :disabled="disabledfilter"
                                            @change="filterItem($event)"
                                        >
                                            <option
                                                v-for="(
                                                    value, index
                                                ) in customData.months"
                                                :key="index"
                                                :value="index"
                                            >
                                                {{ value }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <button
                                    type="button"
                                    class="btn btn-primary"
                                    @click="filterClear()"
                                >
                                    Limpar
                                </button>
                            </div>

                            <div class="table-scroll-wrapper">
                                <!-- Page List Render-->
                                <table-element
                                    :classname="[
                                        'table-striped',
                                        'partner-booking-content',
                                    ]"
                                >
                                    <!-- THead -->
                                    <template #thead>
                                        <tr>
                                            <th scope="col">
                                                <p
                                                    class="color-text-body"
                                                    style="
                                                        border: none;
                                                        padding-left: 0px;
                                                    "
                                                >
                                                    ID
                                                </p>
                                            </th>
                                            <th scope="col">
                                                <p
                                                    class="strong-600 color-text-body border-left"
                                                >
                                                    Parceiro
                                                </p>
                                            </th>
                                            <th scope="col">
                                                <p
                                                    class="color-text-body border-left"
                                                >
                                                    Administrador
                                                </p>
                                            </th>
                                            <th scope="col">
                                                <p
                                                    class="color-text-body border-left"
                                                >
                                                    Localização
                                                </p>
                                            </th>
                                            <th scope="col">
                                                <p
                                                    class="color-text-body border-left"
                                                >
                                                    Espaço
                                                </p>
                                            </th>
                                            <th scope="col">
                                                <p
                                                    class="color-text-body border-left"
                                                >
                                                    Reserva
                                                </p>
                                            </th>

                                            <th scope="col">
                                                <p
                                                    class="color-text-body border-left"
                                                >
                                                    Estado
                                                </p>
                                            </th>
                                            <th scope="col">
                                                <p
                                                    class="color-text-body border-left"
                                                >
                                                    Ações
                                                </p>
                                            </th>
                                        </tr>
                                    </template>

                                    <!-- Tbody -->
                                    <template #tbody>
                                        <tr
                                            v-for="(
                                                valbooking, indexbooking
                                            ) in bookingData"
                                            :key="indexbooking"
                                            :data-referindex="indexbooking"
                                            :data-bookingid="
                                                valbooking.booking_id
                                            "
                                        >
                                            <th scope="row">
                                                <p class="booking-id">
                                                    {{ valbooking.booking_id }}
                                                </p>
                                            </th>
                                            <td>
                                                <p
                                                    class="professional-name border-left strong-600"
                                                >
                                                    {{ valbooking.position }}
                                                </p>
                                            </td>
                                            <td>
                                                <p
                                                    class="office-name border-left"
                                                >
                                                    {{ valbooking.user_create }}
                                                </p>
                                            </td>
                                            <td>
                                                <p
                                                    class="office-name border-left"
                                                >
                                                    {{
                                                        valbooking.location_name
                                                    }}
                                                </p>
                                            </td>
                                            <td>
                                                <p
                                                    class="office-name border-left"
                                                >
                                                    {{ valbooking.office_name }}
                                                </p>
                                            </td>
                                            <td class="d-flex flex-column">
                                                <p class="border-left">
                                                    {{
                                                        `${valbooking.booking_data.day}-${valbooking.booking_data.month}-${valbooking.booking_data.year}`
                                                    }}
                                                </p>
                                                <p class="border-left">
                                                    {{
                                                        `${valbooking.booking_data.turndata.begin}:00 às ${valbooking.booking_data.turndata.end}:00`
                                                    }}
                                                </p>
                                            </td>
                                            <td>
                                                <div class="border-left">
                                                    <p
                                                        :class="
                                                            statusClassname(
                                                                valbooking.status
                                                            )
                                                        "
                                                        class="booking-status"
                                                    >
                                                        {{ valbooking.status }}
                                                    </p>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="border-left">
                                                    <span
                                                        role="button"
                                                        class="btn-active"
                                                        data-action="active"
                                                        :data-bookingid="
                                                            valbooking.booking_id
                                                        "
                                                        :data-status="
                                                            valbooking.status_value
                                                        "
                                                        @click="
                                                            buttonsActions(
                                                                $event
                                                            )
                                                        "
                                                    >
                                                        {{
                                                            valbooking.status_value ===
                                                            1
                                                                ? "Cancelar"
                                                                : "Ativar"
                                                        }}
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                </table-element>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </template>

        <template v-else>
            <h2 class="buttom-body strong-600">
                Necessário criar utilizador indicado como parceiro
            </h2>
        </template>
    </section>
</template>
<script>
import fetchData from "../../../fetchData";
import htmlElements from "./../../../htmlElements";
import responseMessage from "./../../../responseMessage.js";
import Table from "./../../elements/TableElement.vue";

("use strict");

export default {
    name: "BookingAdminCreate",
    props: {
        customdata: {
            type: String,
            required: true,
        },
        csrftolken: {
            type: String,
            required: true,
        },
        bookingurl: {
            type: String,
            required: true,
        },
        statusclassname: {
            type: Function,
            required: true,
        },
        activeurl: {
            type: String,
            required: true,
        },
    },
    data: () => {
        return {
            createbookingobj: {
                day: null,
                month: null,
                year: null,
                location_id: null,
                office_id: null,
                partner_id: null,
                typeoflocation: 1,
                turndata: {
                    begin: null,
                    end: null,
                    turn: null,
                    totalhour: null,
                },
            },
            createbookinglist: [],
            customData: {},
            offices: [],
            transferobj: {},
            disabled: true,
            bookingData: [],
            referenceBookingData: [],
            disabledfilter: false,
        };
    },
    created() {
        //Set Custom Data
        this.customData = JSON.parse(this.customdata);
        let locationid = this.customData.location.find(
            (value, index) => index === 0
        );
        this.getDynamicOfficesByLocation(locationid.id);
        let officeid = this.offices.find((value, index) => index === 0);
        let partnerid = this.customData.partner.find(
            (value, index) => index === 0
        );
        this.bookingData = this.customData.partner_data;

        //Set date
        let date = new Date();
        this.createbookingobj.day = parseInt(date.getDate());
        this.createbookingobj.month = parseInt(date.getMonth() + 1);
        this.createbookingobj.year = parseInt(date.getFullYear());
        this.createbookingobj.location_id = locationid.id;
        this.createbookingobj.office_id = officeid.id;
        this.createbookingobj.partner_id =
            partnerid !== undefined ? partnerid.user_id : null;
        this.createbookingobj.turndata.begin = this.customData.hours.find(
            (value, index) => index === 0
        );
        this.createbookingobj.turndata.end = this.customData.hours.find(
            (value, index) => index === this.customData.hours.length - 1
        );
        this.createbookingobj.turndata.totalhour =
            this.createbookingobj.turndata.end -
            this.createbookingobj.turndata.begin;
    },
    mounted() {},
    methods: {
        statusClassname(status) {
            return this.statusclassname(status);
        },
        setItem(indicate, element, routine) {
            let objel = {
                turndata: {
                    begin: this.createbookingobj.turndata.begin,
                    end: this.createbookingobj.turndata.end,
                },
            };

            switch (routine) {
                case "turndata":
                    objel[routine][indicate] = parseInt(
                        element.currentTarget.value
                    );

                    break;

                default:
                    objel[indicate] = parseInt(element.currentTarget.value);

                    if (indicate === "location_id") {
                        this.getDynamicOfficesByLocation(objel[indicate]);
                    }

                    break;
            }

            Object.assign(this.createbookingobj, objel);
        },
        addBookingDate() {
            let turndata = new Map([
                ["begin", this.createbookingobj.turndata.begin],
                ["end", this.createbookingobj.turndata.end],
                [
                    "totalhour",
                    this.createbookingobj.turndata.end -
                        this.createbookingobj.turndata.begin,
                ],
            ]);

            turndata = Object.fromEntries(turndata);

            this.transferobj = new Map([
                ["day", this.createbookingobj.day],
                ["month", this.createbookingobj.month],
                ["year", this.createbookingobj.year],
                ["location_id", this.createbookingobj.location_id],
                ["office_id", this.createbookingobj.office_id],
                ["partner_id", this.createbookingobj.partner_id],
                ["typeoflocation", this.createbookingobj.typeoflocation],
                ["turndata", turndata],
            ]);

            this.transferobj = Object.fromEntries(this.transferobj);

            if (this.createbookinglist.length === 0) {
                this.createbookinglist.push(this.transferobj);

                this.createHtmlElement(
                    this.transferobj,
                    this.createbookinglist.length
                );
            } else {
                let indexBooking = undefined;

                this.createbookinglist.forEach((value, index) => {
                    if (
                        value.day === this.transferobj.day &&
                        value.month === this.transferobj.month &&
                        value.year === this.transferobj.year &&
                        value.location_id === this.transferobj.location_id &&
                        value.office_id === this.transferobj.office_id
                    ) {
                        let i = value.turndata.begin;

                        do {
                            if (
                                this.createbookingobj.turndata.begin ===
                                    this.transferobj.turndata.begin &&
                                this.transferobj.turndata.end === i
                            ) {
                                indexBooking = index;

                                break;
                            }

                            i++;
                        } while (i <= value.turndata.end);
                    }
                });

                if (indexBooking === undefined) {
                    this.createbookinglist.push(this.transferobj);

                    this.createHtmlElement(
                        this.transferobj,
                        this.createbookinglist.length
                    );

                    return;
                }

                //Render Response Message
                responseMessage.renderResponseMessages(
                    document.querySelector(".responsebasemessage"),
                    "warning",
                    "A data ou hora indicada já está selecionada",
                    "d-flex",
                    5000
                );
            }

            //Enabled Button
            this.disabled = false;
        },
        createHtmlElement(
            bookingdata,
            bookingid,
            parentEl = "create-content-booking"
        ) {
            bookingid = bookingid - 1;

            let baseDiv = htmlElements.createElement("div", {
                class: ` booking-item booking-${bookingdata.day}-${bookingdata.month}-${bookingdata.year}`,
                id: `booking-${bookingdata.day}-${bookingdata.month}-${bookingdata.year}`,
                data_bookingid: `${bookingid}`,
            });

            document.getElementById(parentEl).appendChild(baseDiv);

            let location = this.customData.location.find(
                (value, index) => value.id === bookingdata.location_id
            );
            let office = this.customData.office.find(
                (value, index) => value.id === bookingdata.office_id
            );
            let partner = this.customData.partner.find(
                (value, index) => value.user_id === bookingdata.partner_id
            );

            let pEl = htmlElements.createElement(
                "p",
                {
                    class: "bookinginfo heading-6",
                },
                ` ${office.name} `
            );

            let childDiv = htmlElements.createElement("div", {
                class: "booking-date-hour",
            });

            let pParceria = htmlElements.createElement(
                "p",
                {
                    class: "bookingParceria ",
                },
                `${partner.position}`
            );

            let pLocation = htmlElements.createElement(
                "p",
                {
                    class: "bookinglocation ",
                },
                `${location.name}`
            );

            let pElDate = htmlElements.createElement(
                "p",
                {
                    class: "bookingdate ",
                },
                `${bookingdata.day}-${bookingdata.month}-${bookingdata.year}`
            );

            let small = htmlElements.createElement(
                "p",
                {
                    class: "bookinghour",
                },
                `${bookingdata.turndata.begin}:00 às ${bookingdata.turndata.end}:00`
            );

            baseDiv.appendChild(pEl);
            baseDiv.appendChild(childDiv);
            childDiv.appendChild(pParceria);
            childDiv.appendChild(pLocation);
            childDiv.appendChild(pElDate);
            childDiv.appendChild(small);

            let childDivTwo = htmlElements.createElement("div", {
                class: "booking-actions",
                data_bookingid: `${bookingid}`,
            });

            let spanEl = htmlElements.createElement(
                "span",
                {
                    class: "booking-remove",
                    data_action: "remove",
                    data_bookingid: `${bookingid}`,
                    data_day: `${bookingdata.day}`,
                    data_month: `${bookingdata.month}`,
                    data_year: `${bookingdata.year}`,
                    data_begin: `${bookingdata.turndata.begin}`,
                    data_end: `${bookingdata.turndata.end}`,
                    data_locationid: `${bookingdata.location_id}`,
                    data_officeid: `${bookingdata.office_id}`,
                },
                "Remover"
            );

            baseDiv.appendChild(childDivTwo);
            childDivTwo.appendChild(spanEl);
        },
        getDynamicOfficesByLocation(id) {
            this.offices = this.customData.office.filter(
                (value) => value.location_id === id
            );
        },
        buttonsActions(element) {
            //Enabled Button
            this.disabled = false;

            let booking = element.target;

            //Check Element
            if (
                !booking.hasAttribute("data-action") ||
                !booking.hasAttribute("data-bookingid")
            ) {
                return;
            }

            switch (booking.getAttribute("data-action")) {
                case "remove":
                    let bookingItem = this.createbookinglist.find((value) => {
                        if (
                            value.day ===
                                parseInt(booking.getAttribute("data-day")) &&
                            value.month ===
                                parseInt(booking.getAttribute("data-month")) &&
                            value.year ===
                                parseInt(booking.getAttribute("data-year")) &&
                            value.location_id ===
                                parseInt(
                                    booking.getAttribute("data-locationid")
                                ) &&
                            value.office_id ===
                                parseInt(
                                    booking.getAttribute("data-officeid")
                                ) &&
                            value.turndata.begin ===
                                parseInt(booking.getAttribute("data-begin")) &&
                            value.turndata.end ===
                                parseInt(booking.getAttribute("data-end"))
                        ) {
                            return value;
                        }
                    });

                    if (bookingItem !== undefined) {
                        let indexBookingItem =
                            this.createbookinglist.indexOf(bookingItem);

                        //Remove item from list
                        this.createbookinglist.splice(indexBookingItem, 1);

                        //Remove Element
                        [...document.querySelectorAll(".booking-item")].forEach(
                            (value) => {
                                if (
                                    parseInt(
                                        value.getAttribute("data-bookingid")
                                    ) ===
                                    parseInt(
                                        booking.getAttribute("data-bookingid")
                                    )
                                ) {
                                    value.remove();
                                }
                            }
                        );
                    }

                    //Check Booking List
                    if (this.createbookinglist.length === 0) {
                        //Disabled Button
                        this.disabled = true;
                    }

                    break;

                case "active":
                    let confirmMessage =
                        parseInt(booking.getAttribute("data-status")) === 1
                            ? "Deseja cancelar esta reserva ?"
                            : "Deseja ativar esta reserva ?";

                    //Confirm Booking Create
                    let confirmActive = confirm(confirmMessage);

                    if (!confirmActive) {
                        return;
                    }

                    //Active Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.add("d-flex");

                    this.sendDataStructure(
                        this.activeurl,
                        {
                            id: parseInt(
                                booking.getAttribute("data-bookingid")
                            ),
                            status:
                                parseInt(
                                    booking.getAttribute("data-status")
                                ) === 1
                                    ? 0
                                    : 1,
                        },
                        "PATCH",
                        "active"
                    );

                    break;
            }
        },
        sendData() {
            //Confirm Booking Create
            let confirmCreate = confirm("Confirma a criação da reserva ?");

            if (!confirmCreate) {
                return;
            }

            //Disabled Button
            this.disabled = true;

            //Active Loading
            document.querySelector(".loadingbase").classList.add("d-flex");

            //Check Booking
            if (this.createbookinglist.length === 0) {
                //Desactive Loading
                document
                    .querySelector(".loadingbase")
                    .classList.remove("d-flex");

                //Render Response Message
                responseMessage.renderResponseMessages(
                    document.querySelector(".responsebasemessage"),
                    "danger",
                    "Os dados enviados não são válidos",
                    "d-flex",
                    5000
                );

                return;
            }

            let dataForm = {
                booking: this.createbookinglist,
            };

            //Send Data
            this.sendDataStructure(this.bookingurl, dataForm);
        },
        sendDataStructure(url, dataForm, method = "POST", routine = "create") {
            //Send Data
            let response = fetchData.structureTosendData(
                url,
                dataForm,
                this.csrftolken,
                method
            );

            //Check Promisse
            response
                .then((value) => {
                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    //Render Response Message
                    responseMessage.renderResponseMessages(
                        document.querySelector(".responsebasemessage"),
                        value.classname,
                        value.message,
                        "d-flex"
                    );

                    switch (value.classname) {
                        case "success":
                            if (Object.hasOwn(value, "data")) {
                                if (routine === "create") {
                                    //Clean Data
                                    this.createbookinglist = [];

                                    //Remove Element
                                    [
                                        ...document.querySelectorAll(
                                            ".booking-item"
                                        ),
                                    ].forEach((value) => value.remove());
                                }

                                this.bookingData = value.data;
                            }

                            break;
                    }
                })
                .catch((error) => {
                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    throw new Error(error);
                });
        },
        filterItem(element) {
            let filtervalue = parseInt(element.currentTarget.value);

            //Set Booking Data reference
            if (this.referenceBookingData.length === 0) {
                this.referenceBookingData = this.bookingData;
            }

            let filterData = this.bookingData.filter(
                (value) => value.booking_data.month === filtervalue
            );

            if (filterData.length === 0) {
                //Render Response Message
                responseMessage.renderResponseMessages(
                    document.querySelector(".responsebasemessage"),
                    "warning",
                    "Nenhum resultado encontrado",
                    "d-flex",
                    5000
                );
                return;
            }

            this.bookingData = filterData;

            this.disabledfilter = true;
        },
        filterClear() {
            if (this.referenceBookingData.length > 0) {
                this.bookingData = this.referenceBookingData;
            }

            this.disabledfilter = false;
        },
    },
    computed: {
        computedCreateBookingObj() {
            return this.createbookingobj;
        },
        computedCreateBookingList() {
            return this.createbookinglist;
        },
        computedOfficesList() {
            return this.offices;
        },
        computedBookingData() {
            return this.bookingData;
        },
    },
    watch: {
        computedCreateBookingObj() {},
        computedCreateBookingList() {},
        computedOfficesList() {},
        computedBookingData() {},
    },
    components: {
        tableElement: Table,
    },
};
</script>
